import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { TranslocoPipe } from '@ngneat/transloco';
import { ZardTabComponent, ZardTabGroupComponent } from '@shared/components/ui/tabs/tabs.component';

@Component({
    selector: 'inner-tabbed-page-layout',
    templateUrl: './inner-tabbed-page-layout.component.html',
    styleUrl: './inner-tabbed-page-layout.component.scss',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [MatButtonToggleModule, RouterOutlet, TranslocoPipe, ZardTabComponent, ZardTabGroupComponent],
})
export class InnerTabbedPageLayoutComponent implements OnInit {
    @Input() innerTabs: {
        label: string;
        route?: string;
        primary?: boolean;
    }[] = [];
    activeLink: string;

    constructor(private route: ActivatedRoute, private router: Router) {}

    ngOnInit(): void {
        this.route.data.subscribe((data) => {
            if (data['innerTabs']) {
                this.innerTabs = data['innerTabs'];
            }
        });
        this.router.events.subscribe(() => {
            this.updateActiveLink();
        });

        this.updateActiveLink();
    }
    updateActiveLink(): void {
        const url = this.router.url;
        const activeTab = this.innerTabs.find((tab) => url.includes(tab.route));
        if (activeTab) {
            this.activeLink = activeTab.route;
        } else {
            this.activeLink = '';
        }
    }

    navigateTo(route: string): void {
        this.router.navigate([route], { relativeTo: this.route });
    }

    onTabChange(event: { index: number; label: string; tab: any }): void {
        const selectedTab = this.innerTabs[event.index];
        if (selectedTab && selectedTab.route) {
            this.navigateTo(selectedTab.route);
        }
    }
}
